var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook svg",
    clipPath: "url(#clip0_1491_14201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M15.9554 8.45083C15.9554 4.0853 12.4165 0.54635 8.05096 0.54635C3.68544 0.54635 0.146484 4.0853 0.146484 8.45083C0.146484 12.3962 3.03704 15.6663 6.81589 16.2593V10.7357H4.80889V8.45083H6.81589V6.70937C6.81589 4.72831 7.99597 3.63404 9.80152 3.63404C10.6663 3.63404 11.5709 3.78842 11.5709 3.78842V5.73366H10.5742C9.59226 5.73366 9.28603 6.34297 9.28603 6.96807V8.45083H11.4783L11.1278 10.7357H9.28603V16.2593C13.0649 15.6663 15.9554 12.3962 15.9554 8.45083Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M11.1236 10.7354L11.4741 8.4505H9.28183V6.96775C9.28183 6.34265 9.58805 5.73334 10.57 5.73334H11.5667V3.7881C11.5667 3.7881 10.6621 3.63371 9.79732 3.63371C7.99177 3.63371 6.81168 4.72799 6.81168 6.70905V8.4505H4.80469V10.7354H6.81168V16.259C7.21412 16.3221 7.62659 16.355 8.04676 16.355C8.46693 16.355 8.8794 16.3221 9.28183 16.259V10.7354H11.1236Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1491_14201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.809,
    height: 15.809,
    fill: "white",
    transform: "translate(0.140625 0.545898)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.430b9bcb37670a13be72c6d4eb201990.svg";
export { ForwardRef as ReactComponent };